import { ChevronRight } from 'lucide-react';
import NextStepButton from '../../../../../Components/NextStepButton';
import ProcessingState from '@/Models/ProcessingState';
import UIStrings from '@/Utils/UIStrings';

interface NextButtonComponentProps {
    processingState: ProcessingState;
}

function NextButtonComponent({ processingState }: NextButtonComponentProps) {
    return (
        <NextStepButton
            loading={processingState === ProcessingState.Processing}
            endIcon={<ChevronRight className="size-5" aria-hidden />}
        >
            {UIStrings.Next}
        </NextStepButton>
    );
}

export default NextButtonComponent;
